import { render, staticRenderFns } from "./add-new-offer-to-request.modal.vue?vue&type=template&id=06cfbc97&scoped=true"
import script from "./add-new-offer-to-request.modal.vue?vue&type=script&lang=js"
export * from "./add-new-offer-to-request.modal.vue?vue&type=script&lang=js"
import style0 from "./add-new-offer-to-request.modal.vue?vue&type=style&index=0&id=06cfbc97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cfbc97",
  null
  
)

export default component.exports